module.exports = __webpack_public_path__ + "img/img1.2bed86f0.jpg";